<template>
    <div class="index-container">
        <top-section>ERROR 404</top-section>
        <div class="inner-content">
            <p>The content you're looking for was not found</p>
        </div>
    </div>
</template>
<script>
    export default {
    }
</script>